const InternalTable = ({ columns, rows }) => {
    if (!rows?.length) return null;
    return (
        <div className="table-wrapper show-full-width">
            <table>
                <thead>
                    <tr>
                        {columns.map((column) => <th key={column}>{column}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr
                            key={row.key}
                            className={row.className}
                            onClick={row.onClick}
                            style={row.onClick ? { cursor: "pointer" } : undefined}
                        >
                            {row.span ? (
                                <td colSpan={columns.length}>{row.cells[0]}</td>
                            ) : row.cells.map((cell, index) => <td key={`${row.key}-${index}`}>{cell}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default InternalTable;
